import { Div, RefString, RefSerializer, Select, HidingContentSwitcher, MultilineInput, JsonViewer } from "@tblabs/truffle";
import { Center } from "../../../Components/Utils/Center";
import { CenteredLoader } from "../../../Components/Utils/CenteredLoader";
import { DangerButton } from "../../../Components/Utils/DangerButton";
import { SmallHeader } from "../../../Components/Utils/SmallHeader";
import { OrdersManager } from "../../../Services/OrdersManager";
import { Router } from "../../../Services/Router";


export class AdminOrderRawEditPage extends Div
{
    private loader = new CenteredLoader("Pobieranie zamówienia... Proszę czekać");

    constructor(private _manager: OrdersManager, private _router: Router, private orderId: string)
    {
        super("CustomerPage");

        this.Append(
            this.loader
        );
    }

    protected async OnAppend(): Promise<void>
    {
        const order = await this._manager.GetOneRaw(this.orderId);

        this.loader.RemoveSelf();

        if (!order)
        {
            this.Append(
                new Center(`😥 Nie znaleziono zamówienia. Jego adres jest niepoprawny lub zostało zamknięte albo usunięte.`));
            return;
        }

        const view = new RefString("edit").Storable("order-raw-view");

        const flat = RefSerializer.Flatenize(order);
        const raw = new RefString(JSON.stringify(flat, null, 2));

        this.Append(
            new SmallHeader(`#${order.Id}`),
            new Select(view, ["edit", "json"]).WidthAuto(),
            new HidingContentSwitcher(view)
                .AddContent("edit", () => new MultilineInput(raw).Rows(32))
                .AddContent("json", () => new JsonViewer(flat)),
            new Center(
                new DangerButton("Zapisz").OnClick(() => this._manager.UpdateRaw(order))
            ).Margin(16)
        );
    }
}
